import { render, staticRenderFns } from "./AutoApprovalErrorMessage.vue?vue&type=template&id=3d139daa&scoped=true"
import script from "./AutoApprovalErrorMessage.vue?vue&type=script&lang=ts"
export * from "./AutoApprovalErrorMessage.vue?vue&type=script&lang=ts"
import style0 from "./AutoApprovalErrorMessage.vue?vue&type=style&index=0&id=3d139daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d139daa",
  null
  
)

export default component.exports